import React, { useEffect, useState } from "react";
import { fetchAdmissionCenters, FALLBACK_ADMISSION_CENTERS } from "../../utils/admissionCenters";

/**
 * Center dropdown for add/edit admission — options from tenant settings (API), with fallback list.
 */
export default function AdmissionCenterSelect({ name, value, onChange, token, className = "" }) {
    const [options, setOptions] = useState(FALLBACK_ADMISSION_CENTERS);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const list = await fetchAdmissionCenters(token);
                if (!cancelled && Array.isArray(list) && list.length > 0) {
                    setOptions(list);
                }
            } catch {
                if (!cancelled) setOptions([...FALLBACK_ADMISSION_CENTERS]);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [token]);

    const showSaved =
        Boolean(value) && !options.some((c) => c === value);

    return (
        <select
            name={name}
            value={value}
            onChange={onChange}
            className={className}
        >
            <option value="">Select</option>
            {showSaved && (
                <option value={value}>
                    {value} (saved)
                </option>
            )}
            {options.map((c) => (
                <option key={c} value={c}>
                    {c}
                </option>
            ))}
        </select>
    );
}
